<template>
  <div class="d-flex align-items-center justify-content-between">
    <div>
      <sidebar-collapse />
    </div>
    <div class="d-md-none d-block">
      <img src="/images/logo-horizontal.svg" alt="" height="24" />
    </div>
    <ul class="list-unstyled topbar-right-menu float-end mb-0">
      <OurInnovationsNotificationsPanel class="d-md-block d-none" />
      <PanelNotifications class="d-md-block d-none" />

      <li class="dropdown notification-list">
        <a
          class="nav-link dropdown-toggle nav-user arrow-none me-sm-0 me-2"
          href="javascript:void(0)"
          role="button"
          @click="toggleProfileDropDown"
        >
          <span class="account-user-avatar">
            <base-avatar
              class="avatar-circle-sm"
              :firstname="user.firstname"
              :lastname="user.lastname"
              :randombg="true"
            ></base-avatar>
          </span>
          <span>
            <span class="account-user-name">
              {{ $filters.truncate(user.firstname, 15) }}
              {{ $filters.truncate(user.lastname, 15) }}
            </span>
            <span class="account-position">
              {{ $filters.truncate(this.accountUserName, 50) }}
            </span>
          </span>
        </a>
        <dropdown
          class="dropdown-menu dropdown-menu-right dropdown-menu-animated profile-dropdown"
          item-class="profile-dropdown"
          :show="showProfile"
        >
          <!-- item-->
          <div class="dropdown-header noti-title">
            <h6 class="text-overflow m-0">{{ $t('views.layouts.welcome') }}</h6>
          </div>

          <!-- item-->
          <a href="javascript:void(0);" class="dropdown-item notify-item" @click="onClickMyAccount">
            <i class="mdi mdi-account-circle me-1"></i>
            <span>{{ $t('views.layouts.my_account') }}</span>
          </a>

          <!-- item-->
          <a href="javascript:void(0);" class="dropdown-item notify-item" @click="onClickLogout">
            <i class="mdi mdi-logout me-1"></i>
            <span>{{ $t('views.layouts.exit') }}</span>
          </a>
        </dropdown>
      </li>
    </ul>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'

import { event } from 'vue-gtag'

import BaseAvatar from '@/components/BaseAvatar'
import Dropdown from '@/components/Dropdown'
import SidebarCollapse from '@/components/SidebarCollapse'
import OurInnovationsNotificationsPanel from '@/views/layouts/OurInnovationsNotificationsPanel'
import PanelNotifications from '@/views/layouts/PanelNotifications'

export default {
  components: {
    BaseAvatar,
    OurInnovationsNotificationsPanel,
    PanelNotifications,
    Dropdown,
    SidebarCollapse
  },
  data() {
    return {
      showNotificationContainer: false,
      showProfileContainer: false
    }
  },

  created() {
    window.addEventListener('click', this.close)
  },
  beforeUnmount() {
    window.removeEventListener('click', this.close)
  },
  computed: {
    ...mapState('retailerAuth', ['user']),
    showContainer() {
      return this.showNotificationContainer ? 'show' : ''
    },
    showProfile() {
      return this.showProfileContainer ? 'show' : ''
    },
    accountUserName() {
      return this.user.retailer.alias ? this.user.retailer.alias : this.user.retailer.name
    }
  },
  methods: {
    ...mapActions('retailerAuth', ['logout']),
    toggleNotificationDropDown() {
      this.showNotificationContainer = !this.showNotificationContainer
      this.showProfileContainer = false
    },
    toggleProfileDropDown() {
      this.showProfileContainer = !this.showProfileContainer
      this.showNotificationContainer = false

      event('page_actions', {
        event_action: 'account_clicked'
      })
    },
    onClickMyAccount() {
      event('page_actions', {
        event_action: 'account_opened'
      })

      this.$router.push({ name: 'retailer.account' })
    },
    onClickLogout() {
      event('page_actions', {
        event_action: 'account_logout'
      })

      event('logout')

      this.logout()
    },
    close(e) {
      if (!this.$el.contains(e.target)) {
        this.showProfileContainer = false
        this.showNotificationContainer = false
      }
    }
  }
}
</script>
<style></style>
